"use client";

import ErrorPage from "@/components/ErrorPage";

export default function GlobalError({
  error,
}: Readonly<{ error: Error & { digest?: string } }>) {
  console.error(error);

  return <ErrorPage>try again later</ErrorPage>;
}
